import { createFileRoute } from "@tanstack/react-router";
import { AgendaEventosPage } from "@/paginas/pg_agenda/agenda-eventos";

export const Route = createFileRoute("/_authenticated/agenda-eventos")({
  head: () => ({
    meta: [
      { title: "Agenda — Tipos de evento — Milky Moo Palmares" },
      { name: "description", content: "Criar, editar e excluir tipos de evento da agenda." },
    ],
  }),
  component: AgendaEventosPage,
});
